import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const WhatsAppApi = createApi({
  reducerPath: "WhatsAppApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["WHATSAPPAPI"],
  endpoints: (build) => ({
    getWhatsAppStatus: build.query({
      query: () => ({
        url: `/whatsapp/status`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["WHATSAPPAPI"],
    }),

    connectWhatsApp: build.mutation({
      query: (data) => ({
        url: `/whatsapp/connect`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["WHATSAPPAPI"],
    }),

    disconnectWhatsApp: build.mutation({
      query: () => ({
        url: `/whatsapp/disconnect`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["WHATSAPPAPI"],
    }),

    regenerateWebhookToken: build.mutation({
      query: () => ({
        url: `/whatsapp/regenerate-token`,
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["WHATSAPPAPI"],
    }),
  }),
});

export const {
  useGetWhatsAppStatusQuery,
  useConnectWhatsAppMutation,
  useDisconnectWhatsAppMutation,
  useRegenerateWebhookTokenMutation,
  useLazyGetWhatsAppStatusQuery,
} = WhatsAppApi;